import { SafeBaseObject } from "@app/core/models/base-object.models";
import { ReservationSetupService } from "@app/res-common/models/rescom-service.model";
import { DateTime } from "luxon";

export class ReservationHotelBrand extends SafeBaseObject {
  hotelBrandID = 0;
  hotelBrandName = '';
  status?: string = 'A'

  constructor(data?: any) {
    super();
    if (data) {
      this.updateData(data);
    }
  }
}

export class ReservationHotelChain extends SafeBaseObject {
  hotelChainID = 0;
  hotelChainName = '';
  status?: string = 'A'

  constructor(data?: any) {
    super();
    if (data) {
      this.updateData(data);
    }
  }
}

export interface IReservationAPIGetHotelBrand {
  HotelBrandID?: number;
  HotelBrandName?: string;
}

export interface IReservationAPIManageHotelBrand {
  HotelBrandID?: number;
  HotelBrandName?: string;
  Status?: string;
}

export interface IReservationAPIGetHotelChain {
  HotelChainID?: number;
  HotelChainName?: string;
}
export interface IReservationAPIManageHotelChain {
  HotelChainID?: number;
  HotelChainName?: string;
  Status?: string;
}

export class ReservationHotelUnique extends SafeBaseObject {
  hotelUniqueID = 0
  hotelBrandID = 0
  hotelBrandName = ''
  hotelChainID = 0
  hotelChainName = ''
  hotelDisplayName = ''
  hotelCod = ''
  hotelName = ''
  countryCod = ''
  country = ''
  cityID = 0
  city = ''
  geoTreeID = 0
  geoTreeName = ''
  address = ''
  address2 = ''
  zip = ''
  zip2 = ''
  mail = ''
  phonePrefix = ''
  phone = ''
  latitude = 0
  longitude = 0
  mainServiceID = 0
  serviceLongName = ''
  description = ''
  longDescription = ''
  descriptionAI = ''
  longDescriptionAI = ''
  hotelLevel = 3
  status?: string = 'A'
  services: ReservationhotelUniqueService[] = []
  canEdit = true
  star = ''
  mainServiceIDObject: ReservationSetupService = new ReservationSetupService();
  displayAKORN = false;
  displayTOC = false;
  displayDMC = false;
  displayCK = false;
  serviceType = 3;

  constructor(data?: any) {
    super();
    if (data) {
      this.updateData(data);
      if (data.Services) this.services = data.Services.map((s: any) => new ReservationhotelUniqueService(s))
    }
  }
}

export class ReservationhotelUniqueService extends SafeBaseObject {
  hotelUniqueID: number = 0
  serviceID: number = 0
  serviceLongName: string = ''
  serviceShortName: string = ''
  serviceDescription: string = ''
  supplierName: string = ''
  tradingCompany: string = ''

  constructor(data?: any) {
    super();
    if (data) {
      this.updateData(data);
    }
  }
}


export interface IReservationAPIGetHotelUnique {
  HotelUniqueID?: number
  HotelCod?: string
  HotelName?: string
  HotelBrand?: string
  HotelChain?: string
  CountryCod?: string
  Country?: string
  CityID?: number
  City?: string
  GeoTreeID?: number
  Address?: string
  Latitude?: number
  Longitude?: number
  PackageID?: number
}

export interface IReservationAPIManageHotelUnique {
  HotelUniqueID?: number
  HotelCod?: string
  HotelName?: string
  HotelBrandID?: number
  HotelChainID?: number
  CountryCod?: string
  CityID?: number
  GeoTreeID?: number
  Address?: string
  Address2?: string
  Zip?: string
  Zip2?: string
  Mail?: string
  PhonePrefix?: string
  Phone?: string
  Latitude?: number
  Longitude?: number
  MainServiceID?: number
  HotelLevel?: number
  Description?: string
  LongDescription?: string
  DescriptionAI?: string
  LongDescriptionAI?: string
  Star?: string
  Status?: string;
  DisplayAKORN?: string;
  DisplayTOC?: string;
  DisplayDMC?: string;
  DisplayCK?: string;
}

export class ReservationTSHotelSetup extends SafeBaseObject {
  hotelUniqueSourceID = 0
  companyID = 0
  companyName = ''
  currency = ''
  siteID = 0
  source = ''
  sourceID = 0
  supplierName = ''
  supplierIDLink = 0
  supplierID = 0
  serviceID = 0
  serviceName = ''
  zip = ''
  address = ''
  city = ''
  cityID = 0
  serviceIDLink = 0
  serviceNameLink = ''

  constructor(data?: any) {
    super();
    if (data) {
      this.updateData(data);
    }
  }
}

export interface IReservationAPIGetHotelUniqueSource {
  HotelUniqueSourceID?: number;
  CompanyName?: number;
  Source?: number;
  SourceID?: number;
  SupplierName?: number;
  ServiceName?: number;
  City?: number;
  Address?: number;
  Zip?: number;
  PackageID?: number;
}
export interface IReservationAPIManageHotelUniqueSource {
  HotelUniqueSourceID?: number
  Status?: string
}

export class ReservationSupplier extends SafeBaseObject {
  supplierID = 0
  supplierName = '';
  phone = 0;
  email = '';
  mainContact = '';
  countryCod = 0
  countyID = 0
  stateID = 0
  supplierAccountCod?: string;
  supplierAccountCodBC?: string;
  buyer = ''
  status = 'A';
  country = ''
  address = ''
  currency = ''
  cityID = 0
  city = ''
  RFC = ''
  intercompanyID = 0
  companyID = 0
  supplierUniqueID = 0

  cityAndSupplierName = ''

  constructor(data?: any) {
    super();
    if (data) {
      this.updateData(data);
      if (this.supplierName) this.supplierName = this.supplierName.trim()
      if (this.city) this.city = this.city.trim()
      this.cityAndSupplierName = this.supplierName + (this.city !== '' ? ' - ' + this.city : '')
    }
  }
}

export interface IReservationApiSupplier {
  SupplierID?: number;
  SupplierName?: string;
  CityAndSupplierName?: string;
  Phone?: number;
  Email?: string;
  MainContact?: string;
  CountryCod?: string;
  CountyID?: number;
  StateID?: number;
  SupplierAccountCod?: string;
  SupplierAccountCodBC?: string;
  Buyer?: string;
  Status?: string;
  Country?: string;
  Address?: string;
  Currency?: string;
  CityID?: number;
  City?: string;
  CompanyID?: number;
  IntercompanyID?: number;
  RFC?: string;
  SupplierUniqueID?: number;
}

export class ReservationGeotreeCitySelect extends SafeBaseObject {
  city: string = '';
  cityID: number = 0;
  citySearchable: boolean = true;
  country: string = '';
  countryID: number = 0;
  geoTreeID: number = 0;
  geoTreeName: string = '';
  isCity: boolean = true;
  isPOI = false
  isPort = false;
  portCod = ''

  constructor(data?: any) {
    super();
    if (data) {
      this.updateData(data);
      this.addBooleanProperty('isPort', data, 'IsPort');
    }
  }
}

export interface IReservationApiGeotreeCitySelectParams {
  City?: string;
  CountryID?: number;
  PageSize?: number;
  PageNum?: number;
}

export class ReservationCityLikedGeoTree extends SafeBaseObject {
  cityID = 0
  departmentID = 0
  geoTreeID = 0
  geoTreeName = ''

  constructor(data?: any) {
    super();
    if (data) {
      this.updateData(data);
    }
  }
}
export class ReservationGeotreeCity extends SafeBaseObject {
  city: string | null = '';
  cityID: number | null = 0;
  citySearchable = true;
  country?: string;
  countryID: number | null = 0;
  isCity = true;
  cityCity?: string;
  cityRgn?: string;
  cityCruise?: string;
  cityCod?: string;
  portCod?: string;
  cityStatusID = 1;
  cityTypeID?: number;
  latitude?: number;
  longitude?: number;
  circleLatitude?: number;
  circleLongitude?: number;
  mainIataCod?: string;
  isPOI = false;
  geoTree: ReservationCityLikedGeoTree[] = []


  constructor(data?: any) {
    super();
    if (data) {
      this.updateData(data);
      if (data.GeoTree) this.geoTree = data.GeoTree.map((g: any) => new ReservationCityLikedGeoTree(g))
    }
  }
}

export class ResSupplierDepScheduling extends SafeBaseObject {
  supplierDepositSchedulingID: number = 0;
  packageID: number = 0;
  paymentDueDays: number = 0;
  paymentDateFromType = 'CreationDate'
  isFinalPayment: boolean = false;
  amount: number | null = null
  percentage: number | null = null
  currency: string = '';
  status: string = '';
  startDate: DateTime = DateTime.invalid('empty');
  endDate: DateTime = DateTime.invalid('empty');

  formattedStartDate: string = '';
  formattedEndDate: string = '';

  multiCurrencyID: string = '';

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
    this.formatDateTimeProperties()

    // fe logic
    this.multiCurrencyID = `${this.paymentDueDays}-${this.paymentDateFromType}-${this.isFinalPayment}-${this.formattedStartDate}-${this.formattedEndDate}`;
  }

  override updateData(data: any): void {
    this.addMangledProperty(data);
  }

  get deleted(): boolean {
    return this.status?.toLowerCase() === 'd';
  }

  get available(): boolean {
    return this.status?.toLowerCase() === 'a';
  }
}

export class ResSupplierCancPolicy extends SafeBaseObject {
  supplierCancellationPolicyID: number = 0;
  packageID: number = 0;
  status: string = '';
  details: ResSupplierCancPolicyDetail[] = [];
  startDate: DateTime = DateTime.invalid('empty');
  endDate: DateTime = DateTime.invalid('empty');

  get airDetails(): ResSupplierCancPolicyDetail[] {
    return this.details.filter((d) => d.isAir);
  }
  get packageDetails(): ResSupplierCancPolicyDetail[] {
    return this.details.filter((d) => !d.isAir);
  }

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);

    if (data?.Details) this.details = data.Details.map((d: any) => new ResSupplierCancPolicyDetail({ ...d, StartDate: this.startDate, EndDate: this.endDate }));
  }

  override updateData(data: any): void {
    this.addMangledProperty(data);
  }

  get deleted(): boolean {
    return this.status?.toLowerCase() === 'd';
  }

  get available(): boolean {
    return this.status?.toLowerCase() === 'a';
  }
}

export class ResSupplierCancPolicyDetail extends SafeBaseObject {
  supplierCancellationPolicyDetailID: number = 0;
  supplerCancellationPolicyID: number = 0;
  packageID: number = 0;
  daysFrom: number = 0;
  daysTo: number = 0;
  amountPerc: number | null = null
  fixedAmount: number | null = null
  status: string = '';
  valueType: string = '';
  startDate: DateTime = DateTime.invalid('empty');
  endDate: DateTime = DateTime.invalid('empty');
  currency: string = '';

  formattedStartDate: string = '';
  formattedEndDate: string = '';

  // fe logic
  multiCurrencyID: string = '';

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
    this.formatDateTimeProperties()

    this.multiCurrencyID = `${this.daysFrom}-${this.daysTo}-${this.valueType}-${this.formattedStartDate}-${this.formattedEndDate}`;
  }

  override updateData(data: any): void {
    this.addMangledProperty(data);
  }

  get deleted(): boolean {
    return this.status?.toLowerCase() === 'd';
  }

  get available(): boolean {
    return this.status?.toLowerCase() === 'a';
  }

  get isAir(): boolean {
    return this.valueType === 'INTERNAL AIR';
  }
}

export interface IReservationAPIGetSandersonPhillips {
  HotelUniqueID?: number;
  Name?: string;
}

export class ReservationSandersonPhillips extends SafeBaseObject {
  id = 0;
  name = '';
  place = '';
  region = '';
  country = '';
  countryCode = '';
  hotelUniqueID = 0;
  sandersonPhillips2OneISHotelID = 0;
  hotelName = '';

  constructor(data?: any) {
    super();
    if (data) {
      this.updateData(data);
    }
  }
}

export interface IResApiManageSandersonPhillips {
  SandersonPhillips2OneISHotelID?: number;
  HotelUniqueID?: number;
  ID?: number;
  Status?: string;
}

export class ReservationHotelAuditListItem extends SafeBaseObject {
  hotelUniqueID = 0;
  hotelName = '';
  hotelBrandID = 0;
  hotelBrandName = '';
  hotelChainID = 0;
  hotelChainName = '';
  star = '';
  displayAKORN = false;
  displayTOC = false;
  displayDMC = false;
  displayCK = false;
  country = '';
  cityID = 0;
  city = '';
  geoTreeID = 0;
  geoTreeName = '';
  address = '';
  zip = '';
  mail = '';
  phonePrefix = '';
  phone = '';
  latitude = 0;
  longitude = 0;
  status = '';
  salesDescription = '';
  salesDescriptionAI = '';
  carouselImage = '';
  image1 = '';

  constructor(data?: any) {
    super();
    if (data) {
      this.updateData(data);
    }
  }
}

export class ReservationHotelAudit extends SafeBaseObject {
  auditID = 0;
  providerID = 0;
  auditType = '';
  auditName = '';
  latestDate = DateTime.invalid('empty');
  previousGrade = '';
  currentGrade = '';
  gradeDescription = '';
  latestGradeChangeDate = DateTime.invalid('empty');

  grades: ReservationHotelAuditGradesAndReasons[] = [];
  reasons: ReservationHotelAuditGradesAndReasons[] = [];

  constructor(data?: any) {
    super();
    if (data) {
      this.updateData(data);
      if (data.Grades) this.grades = data.Grades.map((g: any) => new ReservationHotelAuditGradesAndReasons(g))
      if (data.Reasons) this.reasons = data.Reasons.map((r: any) => new ReservationHotelAuditGradesAndReasons(r))
    }
  }
}

export class ReservationHotelAuditGradesAndReasons extends SafeBaseObject {
  auditID = 0;
  fromGrade = '';
  fromGradeMeaning = '';
  toGrade = '';
  toGradeMeaning = '';
  gradeChangeDate = DateTime.invalid('empty');

  reasons = ''
  advice = ''
  instructions = ''

  constructor(data?: any) {
    super();
    if (data) {
      this.updateData(data);
    }
  }
}